export type Feature =
    | 'checklist'
    | 'client-abc'
    | 'management-tools'
    | 'management-tools-dashboard'
    | 'organization'
    | 'organization-dashboard'
    | 'organization-dates'
    | 'organization-integrations'
    | 'organization-settings'
    | 'organization-targets'
    | 'sales-performance'
    | 'statistics'
    | 'workflow-designer'
    | 'workspace';

export type Permission =
    // Checklist
    | 'create-checklist'
    | 'edit-checklist'
    | 'view-checklist'
    // Particle
    | 'pend-particles'
    | 'send-particles'
    | 'utilise-folders'
    // Client ABC
    | 'view-company-client-abc'
    | 'view-own-client-abc'
    | 'create-own-custom-groups'
    | 'create-company-custom-groups'
    // Statistics
    | 'view-company-statistics'
    | 'view-own-statistics'
    // Sales Performance (OE-293)
    | 'view-own-sales-performance'
    | 'view-company-sales-performance'
    | 'manage-sales-performance'
    // Workflow Designer
    | 'view-workflow-designer'
    | 'create-workflow'
    | 'edit-workflow'
    | 'delete-workflow'
    | 'publish-workflow'
    | 'manage-workflow-templates'
    | 'assign-workflow-permissions'
    // Organization Board
    | 'edit-organization-board'
    | 'manage-org-users'
    | 'manage-org-hats'
    | 'manage-org-security-groups'
    | 'manage-org-policies';
